import { Property } from './property';

export class ComparableRentals {
    constructor(doc) {
        this.comparableRentalList = [];
        for (let property of doc) {
            var cr = new ComparableRental(property);
            //console.log("cr: ", cr);
            this.comparableRentalList.push(cr);
        }
    }

    GetComparableRentalImages() {
        const images = [];
        const title = "Comparable #";
        let index = 0;
        for (let property of this.comparableRentalList) {
            const img = property.GetPropertyImage();
            img.imageSourceCaption = title + (++index).toString();
            images.push(property.GetPropertyImage());
        }
        return images;
    }

    GetComparableRentalByInformationLabel(label) {
        for (let property of this.comparableRentalList) {
            for (let improv of property.improvements.improvementList) {
                for (let units of improv.propertyUnits) {
                    for (let rental of units.rentalInformations) {
                        if (rental.label === label) return property;
                    }
                }
            }
        }
        return null;
    }
}

class ComparableRental extends Property {
    // constructor(doc) {
    //     super(doc);
    // }

    GetImprovementByInformationLabel(label) {
        for (let i of this.improvements.improvementList) {
            for (let pu of i.propertyUnits) {
                if (pu.rentalInformations) {
                    for (let rental of pu.rentalInformations) {
                        if (rental.label === label) return i;
                    }
                }
            }
        }
        return null;
    }

    GetPropertyUnitByInformationLabel(label) {
        for (let i of this.improvements.improvementList) {
            for (let pu of i.propertyUnits) {
                if (pu.rentalInformations) {
                    for (let rental of pu.rentalInformations) {
                        if (rental.label === label) return pu;
                    }
                }
            }
        }
        return null;
    }

    GetRentalInformationByInformationLabel(label) {
        for (let i of this.improvements.improvementList) {
            for (let pu of i.propertyUnits) {
                if (pu.rentalInformations) {
                    for (let rental of pu.rentalInformations) {
                        if (rental.label === label) return rental;
                    }
                }
            }
        }
        return null;
    }

    GetLeaseStartDate() {
        for (let i of this.improvements.improvementList) {
            for (let pu of i.propertyUnits) {
                if (pu.unitRentSchedule) {
                    return pu.unitRentSchedule.leaseStartDate;
                    }
                }
            }
        return null;
    }

    GetUnitRentSchedule() {
        for (let i of this.improvements.improvementList) {
            for (let pu of i.propertyUnits) {
                if (pu.unitRentSchedule) {
                    return pu.unitRentSchedule;
                    }
                }
            }
        return null;
    }

}
